import React from "react";
import PropTypes from "prop-types";
import { Event } from "../Tracking";

const DeviceFilterListItem = props => (
  <li style={{ display: 'block', listStyle: 'none', padding: 0, margin: 0 }}>
    <p
      onClick={() => {
        Event("Filter Devices Event", "Submeter-Category", props.category.name);
        props.handleFilterUpdated({
          category: props.category.name,
          purpose: null,
          subpurpose: null
        });
      }}
      style={{
        margin: 0,
        padding: '6px 0 6px 12px',
        cursor: 'pointer',
        fontWeight: 'bold',
        borderLeft: props.submeterCategory === props.category.name
          ? '4px solid #f06c00'
          : '4px solid transparent',
      }}
    >
      {props.category.name}
    </p>

    {props.submeterCategory === props.category.name && (
      <ul style={{ display: 'block', listStyle: 'none', padding: 0, margin: 0, paddingLeft: '24px' }}>
        {props.category["submeter-purpose"].map((purpose, index) => (
          <li key={index} style={{ display: 'block', listStyle: 'none', padding: 0, margin: 0 }}>
            <p
              onClick={() => {
                Event("Filter Devices Event", "Submeter-Purpose", purpose.name);
                props.handleFilterUpdated({
                  category: props.submeterCategory,
                  purpose: purpose.name,
                  subpurpose: null
                });
              }}
              style={{
                margin: 0,
                padding: '6px 0',
                cursor: 'pointer',
                fontWeight: props.submeterPurpose === purpose.name ? 'bold' : 'normal',
              }}
            >
              {purpose.name}
            </p>

            {props.submeterPurpose === purpose.name && (
              <ul style={{ display: 'block', listStyle: 'none', padding: 0, margin: 0, paddingLeft: '16px' }}>
                {purpose["submeter-sub-purpose"].map((subpurpose, index) => (
                  <li key={index} style={{ display: 'block', listStyle: 'none', padding: 0, margin: 0 }}>
                    <p
                      onClick={() => {
                        Event("Filter Devices Event", "Submeter-Sub-Purpose", subpurpose.name);
                        props.handleFilterUpdated({
                          category: props.submeterCategory,
                          purpose: props.submeterPurpose,
                          subpurpose: subpurpose.name
                        });
                      }}
                      style={{
                        margin: 0,
                        padding: '6px 0',
                        cursor: 'pointer',
                        fontWeight: props.submeterSubpurpose === subpurpose.name ? 'bold' : 'normal',
                      }}
                    >
                      {subpurpose.name}
                    </p>
                  </li>
                ))}
              </ul>
            )}
          </li>
        ))}
      </ul>
    )}
  </li>
);

DeviceFilterListItem.propTypes = {
  handleFilterUpdated: PropTypes.func,
  category: PropTypes.object,
  submeterCategory: PropTypes.string,
  submeterPurpose: PropTypes.string,
  submeterSubpurpose: PropTypes.string
};

export default DeviceFilterListItem;
